import { CustomCanonVendorReportingDetailsComponent } from './components/custom-canon-vendor-reporting-details/custom-canon-vendor-reporting-details.component';
import {
    CustomVendorReportingSearchFilters,
    CustomVendorReportingSortOptions,
    ReportCategory,
    ReportChannel,
    ReportTransferStatus,
    ReportTransferType,
  } from './custom-vendor-reporting.models';
  
  export class CustomVendorReportingUtils {
  
    static readonly DATE_FIELDS_FORMAT = 'yyyy-MM-dd';
    static readonly rioEmployeeB2BUnit ='RIO-VendorReporting';
  
    static initSearchFilters(): CustomVendorReportingSearchFilters {
      return {
        productCode: '',
        supplierProductCode: '',
        ean: '',
        manufacturer: '',
        reportTransferType:'',
        reportTransferStatus: '',
        reportTransferPeriod: '',
        transferDateFrom: '',
        transferDateTo: '',
        b2bUnit: '',
        reportCategory:ReportCategory[ReportCategory.Daily],
        reportChannel: ''
      };
    }

    static initDataEvaluationSearchFilters(): CustomVendorReportingSearchFilters {
      return {
        productCode: '',
        supplierProductCode: '',
        ean: '',
        manufacturer: '',
        reportTransferType:'',
        reportTransferStatus: '',
        reportTransferPeriod: '',
        transferDateFrom: '',
        transferDateTo: '',
        b2bUnit: '',
        reportCategory:ReportCategory[ReportCategory.Daily]
      };
    }
  
    static getDefaultTransferDateFrom(date: Date): Date {
      date.setDate(date.getDate() - 90);
      return date;
    }

    static getDefaultRioTransferDateFrom(date: Date): Date {
      date.setFullYear(new Date().getFullYear()); 
      date.setMonth(0);
      date.setDate(1);
      return date;
  }
  

    static applyRioDashBoardDateFilter(reportCategory:String, today: Date):Date{

        const reportDate = new Date();
        if (reportCategory === ReportCategory[ReportCategory.Daily])
           {
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(today.getDate() - 7);
          return sevenDaysAgo;
        }
        if (reportCategory === ReportCategory[ReportCategory.Weekly]) {
          const fourWeeksAgo = new Date();
          fourWeeksAgo.setDate(today.getDate() - 28); // 4 weeks * 7 days
          return  fourWeeksAgo;
        }
  
        if (reportCategory === ReportCategory[ReportCategory.Monthly] || reportCategory ==='') {
          const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
          return  threeMonthsAgo;
        }
        return reportDate;
    }
  
    static getReportTransferStatusColor(status: ReportTransferStatus): string {
      switch (status) {
        case ReportTransferStatus.Error:
        case ReportTransferStatus.NoData:
          return 'red';
        case ReportTransferStatus.Success:
          return 'green';
        case ReportTransferStatus.DataModified:
          return 'orange';
        default:
          return 'standard';
      }
    }

    static compare (selectedSortOption: string, v1: string | number | Date, v2: string | number | Date): number { 
      if (selectedSortOption === CustomVendorReportingSortOptions[CustomVendorReportingSortOptions.timeStamp]) {
        v1 = v1 ? new Date(v1) : new Date();
        v2 = v2 ? new Date(v2) : new Date();
        return v1.getTime() < v2.getTime() ? -1 : v1.getTime() > v2.getTime() ? 1 : 0;
      }
      return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
    }
  }